/**
 * Filter der Vergleichsuebersicht.
 *
 * Filtert nach Ergebnisformat, nicht nach Zielgruppe — das ist Absicht.
 * Ohne JavaScript sind alle Vergleiche sichtbar, die Filterleiste wird dann
 * schlicht nicht bedienbar.
 *
 * Erwartet:
 *   <button class="filter__knopf" data-filter="messwerte" aria-pressed="false">
 *   <article class="filter-eintrag" data-format="messwerte" data-kategorie="...">
 *   <span id="filter-anzahl">
 */
(function () {
  "use strict";

  var leiste = document.querySelector("[data-filterleiste]");
  if (!leiste) return;

  var knoepfe = leiste.querySelectorAll(".filter__knopf");
  var eintraege = document.querySelectorAll(".filter-eintrag");
  var anzeige = document.getElementById("filter-anzahl");
  var leerHinweis = document.getElementById("filter-leer");

  if (!knoepfe.length || !eintraege.length) return;

  var aktiv = "alle";

  var anwenden = function () {
    var sichtbar = 0;

    Array.prototype.forEach.call(eintraege, function (eintrag) {
      // Ein Bericht kann mehrere Ergebnisformate kombinieren. data-format
      // enthält sie dann durch Leerzeichen getrennt, und der Bericht soll
      // unter jedem davon gefunden werden.
      var formate = (eintrag.getAttribute("data-format") || "").split(/\s+/);
      var passt = aktiv === "alle" || formate.indexOf(aktiv) !== -1;

      eintrag.classList.toggle("ist-versteckt", !passt);
      if (passt) sichtbar++;
    });

    if (anzeige) {
      anzeige.textContent =
        sichtbar + (sichtbar === 1 ? " Testbericht" : " Testberichte");
    }

    if (leerHinweis) {
      leerHinweis.hidden = sichtbar > 0;
    }
  };

  Array.prototype.forEach.call(knoepfe, function (knopf) {
    knopf.addEventListener("click", function () {
      aktiv = knopf.getAttribute("data-filter") || "alle";

      Array.prototype.forEach.call(knoepfe, function (k) {
        k.setAttribute("aria-pressed", k === knopf ? "true" : "false");
      });

      anwenden();
    });
  });

  anwenden();
})();
